exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".topMenu{background-color:#ffb122;box-sizing:border-box;overflow:hidden;border-bottom:1px solid #c76b00;position:fixed;right:0;left:0;z-index:1000;transition:all .4s ease;height:50px}.topMenu.m-toggle{left:285px}.topMenu.m-expanded{height:235px}@media (min-width:992px){.topMenu{overflow:inherit;left:285px;height:80px}.topMenu.m-toggle{left:0}.topMenu.m-expanded{height:80px}}.topMenu--expand{display:block}@media (min-width:992px){.topMenu--expand{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/components/topMenu/topMenu.styl
// module id = 746
// module chunks = 0